module.exports = __webpack_public_path__ + "img/icon-68.02ceb3ec.svg";